import { Box, Stack, Button } from '@mui/material'
import Admin from 'api/Admin';
import Input from 'components/Input'
import useForm from 'js/hooks/useForm';
import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap'


const today = new Date().toISOString().split('T')[0];

const schema = [
    {
        label: "Planned Repayment Date",
        name: "planned_date",
        type: "date",
        min: today,
        error: { required: true }
    },
    {
        label: "Planned Repayment Amount (₹)",
        name: "planned_repayment_amt",
        type: "number",
        error: { required: true }
    }
]

export default function CreateRepayment({ onChange, data: prev }) {

    const [payload, setPayload] = useState(null)
    const { data, inputProps, isError, setData, setTouched } = useForm({ schema })
    const { id: case_id } = useParams()
    const onCancel = () => {
        setData({})
        setPayload(null)
    }

    const onSubmit = async () => {
        if (isError()) {
            setTouched(true)
            return
        }

        try {
            const updatedSchedule = [...prev.repayment_details]
            updatedSchedule[updatedSchedule.length] = {
                ...data,
                repayment_date: null,
                repayment_status: "pending",
                created_by: 0,
                updated_by: 0,
                actual_repayment_amt: "0.00",
                outstanding_amt: "0.00",
                tot_repayed_amt: "0.00",
                repayment_txn_info: null,
            };

            const payload = {
                ...prev,
                repayment_count: updatedSchedule.length,
                repayment_details: updatedSchedule,
            };
            const res = await Admin.Repayment.create({ case_id, payload })
            onChange(payload)
            setData({})
            setPayload(null)
        } catch (error) {
            alert(error.message)
        }
    }

    return (
        <div>
            <a onClick={() => setPayload({})} style={{ color: "blue", cursor: "pointer" }}>+ New Row</a>
            <Modal isOpen={payload} toggle={onCancel}>
                <Box sx={{ borderBottom: "1px solid #0003", px: 2, pt: 1 }}>
                    <h3>Plan New Disbursement</h3>
                </Box>
                <ModalBody>
                    <Stack spacing={2}>
                        {schema.map(d => <Input {...inputProps(d)} />)}
                        <br />
                        <Stack flexDirection={"row"} justifyContent={"space-between"}>
                            <Button onClick={onCancel} variant='outlined' color='error'>Cancel</Button>
                            <Button onClick={onSubmit} variant='contained'>Submit</Button>
                        </Stack>
                    </Stack>
                </ModalBody>
            </Modal>
        </div>
    )
}
